import moment from 'moment';
import React from 'react';
import Modal from '../../Components/Modal/Modal';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';
import './OrderHistory.scss';
import { Button } from '../../Components/StyledComponents';
import PickupOrderHistoryModal from './PickupOrderHistoryModal';
import { alertRef } from '../../App';

const statusList = {
    Reject: '거절',
    Canceled : '주문취소',
    CancelFailed : '취소실패',
    CancelAccept: '수락후취소',
    Pending : '접수대기',
    Accepted: '준비 중',
    Cooked: '준비완료',
    RequestPickup: '픽업호출',
    Pickup : '픽업완료'
}

const variant = {
    Reject: 'danger',
    Canceled : 'danger',
    CancelFailed : 'danger',
    CancelAccept: 'danger',
    Pending : 'primary',
    Accepted: 'primary',
    Cooked: 'primary',
    RequestPickup: 'success',
    Pickup : 'success'
}

const PickupOrderHistory = () => {
    const modalRef = React.useRef(null);
    const [ isDownloading, setIsDownloading ] = React.useState(false);

    const columns = React.useMemo(
        () => [
          {
            /* Header: '메뉴를 검색해보세요.', */
            Header: '메뉴',
            accessor: 'Menu', // accessor is the "key" in the data
            disableSortBy : true,
            Cell : (props) => {
              return (
                <p className='table-title' style={{whiteSpace: 'pre-wrap'}}>{props.cell.value}</p>
              )
            },
            width : 400,
            minWidth : 400
          },
          {
            Header: '주문일시',
            accessor: 'OrderDate.$date',
            disableFilters : true,
            minWidth : 150,
            width : 150,
            Cell : (props) => {
                return(
                    <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                )
            }
          },
          {
            Header: '선불여부',
            accessor: 'Paid',
            disableFilters : true,
            minWidth : 120,
            maxWidth : 120,
            width : 120,
            Cell : (props) => {
                return(
                  <p className={props.cell.value ? 'primary-text' : 'canceled-text'}>{props.cell.value ? `선불` : '후불'}</p>
                )
            }
          },
          {
            Header: '카드사',
            accessor: 'Card',
            disableFilters : true,
            minWidth : 120,
            maxWidth : 120,
            width : 120,
            Cell : (props) => {
                return(
                  <p className='info-text'>{props.cell.value ? props.cell.value : '-'}</p>
                )
            }
          },
          {
            Header: '결제금액',
            accessor: 'Price',
            disableFilters : true,
            minWidth : 120,
            maxWidth : 120,
            width : 120,
            Cell : (props) => {
                return(
                    <p className='info-text'>{convertCost(props.cell.value)}원</p>
                )
            }
          },
          {
            Header: '상태',
            accessor: 'Status',
            disableFilters : true,
            isDropdown : true,
            options : [
              { key : 'test1' , value : 'Ccc11'},
              { key : 'test2' , value : '22'},
              { key : 'test3' , value : '33'},
              { key : 'test4' , value : '44'},
            ],
            Cell : (props) => {
                return(
                    <StatusBadge Status={statusList[props.cell.value]} variant={variant[props.cell.value]}/>
                )
            },
            minWidth : 144,
            width : 144
          },
        ]
    )

    const downLoadHistory = async (startDate, endDate, paymentInfo = false) => {
      let url = `/api/van/history/pickup/order/menu/xlsx/${startDate}/${endDate}`;
      if(paymentInfo) {
        url = `/api/van/history/pickup/order/xlsx/${startDate}/${endDate}`;
      }
      try {
        setIsDownloading(true);
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error('주문내역을 다운받는 중 오류가 발생했습니다.');
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `픽업오더_주문내역_${startDate}_${endDate}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
        
        modalRef.current.closeModal();
      } catch (error) {
        alertRef.current.showAlert({ title: '다운로드에 실패했습니다.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
      } finally {
        setIsDownloading(false);
      }
    };

    return (
        <div className='order-history'>
          <Button variant="main" small onClick={() => modalRef.current.openModal()}>
            주문내역 다운로드
          </Button>
          <Table columns={columns} url={'/api/van/history/pickup/order'}/>

          <Modal ref={modalRef} contentContainer={{ width: 600 }} isHeader title="픽업오더 주문내역 다운로드">
            <PickupOrderHistoryModal downLoadHistory={downLoadHistory} isDownloading={isDownloading} />
          </Modal>
        </div>
    )
}

export default PickupOrderHistory;